// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"34f50ba2","450":"1523c71d","453":"54292a4b","731":"5aa3c4f0"}[chunkId] + ".chunk.js";
};